import _ from 'lodash'
import introJs from 'intro.js'

const intro = introJs()

class IntroJs {
    start (steps = [], options = {}) {
        intro
            .setOptions({
                overlayOpacity: 100,
                nextLabel: 'Next',
                prevLabel: 'Prev',
                showBullets: false,
                showProgress: false,
                showStepNumbers: false,
                steps: _.filter(steps, step => {
                    return _.isFunction(step.when)
                        ? step.when()
                        : true
                })
            })
            .start()

        return this
    }

    exit () {
        intro.exit()
    }

    oncomplete (callback) {
        intro.oncomplete(callback)
    }

    onafterchange (callback) {
        intro.onafterchange(element => {
            callback(element, intro)
        })
    }
}

export default function (Vue) {
    Vue.prototype.$introjs = new IntroJs()
}
